module.exports = __webpack_public_path__ + "static/media/homedark.3f6cde1d.svg";